// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__s2zEz","wrapper":"style__wrapper__MNYfx"};